/**
 * Etiqueta verde de las cajas que llevan factura (`LlevaFactura_MDP='SI'`).
 * Es lo que distingue "Efectivo Pesos" de su gemela "Efectivo Pesos N" — ver
 * `shared/lib/cajasEfectivo.ts`.
 */
export function LlevaFacturaTag({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <span className="inline-flex shrink-0 whitespace-nowrap rounded-md bg-emerald-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-4 tracking-wide text-emerald-700">
      Lleva factura
    </span>
  );
}
